import HubspotForms from './components/HubspotForms';
import InteractiveImage from './components/InteractiveImage';
import NavMenu from './components/NavMenu';
import VideoEmbed from './components/VideoEmbed';
import VideoLightbox from './components/VideoLightbox';

class Controller {
    constructor() {
        this.init();

        window.addEventListener('resize', this.resized, { passive: true });
        window.addEventListener('load', this.loaded, false);
    }

    init() {
        (function($) {
            NavMenu.init();
            InteractiveImage.init();
            HubspotForms.init();
            VideoEmbed.init();
            VideoLightbox.init();
        })(jQuery);
    }

    resized() {
        NavMenu.resized();
        VideoLightbox.resized();
    }

    loaded() {
        NavMenu.loaded();
    }
}


// Run controller.
new Controller();